module.exports = __webpack_public_path__ + "img/file-magnifying-glass.4039ca52.svg";